import { render } from "./PromotionListView.vue?vue&type=template&id=c9733272&scoped=true&ts=true"
import script from "./PromotionListView.vue?vue&type=script&lang=ts"
export * from "./PromotionListView.vue?vue&type=script&lang=ts"

import "./PromotionListView.vue?vue&type=style&index=0&id=c9733272&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9733272"]])

export default __exports__